'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_KeySetter(key, value, action) {
  this.GU = null;
  this.GV = null;
  this.GT = null;
  this.GU = key;
  this.GV = value;
  this.GT = action;
}
export { $c_Lcom_raquo_laminar_modifiers_KeySetter as $c_Lcom_raquo_laminar_modifiers_KeySetter };
$p = $c_Lcom_raquo_laminar_modifiers_KeySetter.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_KeySetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_KeySetter() {
}
export { $h_Lcom_raquo_laminar_modifiers_KeySetter as $h_Lcom_raquo_laminar_modifiers_KeySetter };
$h_Lcom_raquo_laminar_modifiers_KeySetter.prototype = $p;
$p.dL = (function(element) {
  this.GT.jj(element, this.GU, this.GV);
});
var $d_Lcom_raquo_laminar_modifiers_KeySetter = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_KeySetter, "com.raquo.laminar.modifiers.KeySetter", ({
  iu: 1,
  ab: 1,
  cY: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_KeySetter as $d_Lcom_raquo_laminar_modifiers_KeySetter };
